
import { PaletteOptions } from '@mui/material/styles';

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#D97706', // Amber accent color
    light: '#F59E0B',
    dark: '#B45309',
    contrastText: '#000000',
  },
  secondary: {
    main: '#6B7280',
    light: '#9CA3AF',
    dark: '#4B5563',
  },
  background: {
    default: '#0F0F0F', // Very dark background
    paper: '#1A1A1A', // Slightly lighter for surfaces
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#D1D5DB',
    disabled: '#6B7280',
  },
  divider: 'rgba(255, 255, 255, 0.08)',
  action: {
    active: '#FFFFFF',
    hover: 'rgba(255, 255, 255, 0.08)',
    selected: 'rgba(217, 119, 6, 0.15)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
  },
};

export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#B45309',
    light: '#D97706',
    dark: '#78350F',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#5F6875',
    light: '#8B94A1',
    dark: '#3F4752',
  },
  background: {
    default: '#F7F5F2',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#241F1A',
    secondary: '#665F57',
    disabled: '#9A9288',
  },
  divider: 'rgba(77, 63, 49, 0.14)',
  action: {
    active: '#51483F',
    hover: 'rgba(83, 68, 52, 0.055)',
    selected: 'rgba(180, 83, 9, 0.10)',
    disabled: 'rgba(36, 31, 26, 0.34)',
    disabledBackground: 'rgba(36, 31, 26, 0.10)',
  },
};

export const sepiaPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#B45309',
    light: '#D97706',
    dark: '#78350F',
    contrastText: '#FDF6E2',
  },
  secondary: {
    main: '#8B5A2B',
    light: '#A08060',
    dark: '#5C4033',
  },
  background: {
    default: '#FDF6E2', // Warm cream background
    paper: '#F4ECD8',   // Lighter sepia surface
  },
  text: {
    primary: '#5C4033', // Dark brown sepia text
    secondary: '#8B5A2B',
    disabled: '#A08060',
  },
  divider: 'rgba(92, 64, 51, 0.15)',
  action: {
    active: '#5C4033',
    hover: 'rgba(92, 64, 51, 0.06)',
    selected: 'rgba(180, 83, 9, 0.1)',
    disabled: 'rgba(92, 64, 51, 0.3)',
    disabledBackground: 'rgba(92, 64, 51, 0.12)',
  },
};
